import { useRuntimeConfig } from '#app'
import type { Env } from '~/types/environment'
import type { AppInsightsConfig } from '~/utils/deferredAppInsights'
import type { ValueByCulture } from '~/types/root'

type AuthEndpointConfig = {
  path: string
  method: string
}

type AuthRuntimeConfig = {
  provider: {
    endpoints: {
      getSession: AuthEndpointConfig
      signIn: AuthEndpointConfig
    }
  }
}

type I18nRuntimeConfig = {
  fallbackLocale: string
}

export type AppPublicRuntimeConfig = {
  API_PREFIX: string
  API_PORT?: string | number
  CHAT_FLOW_ID?: ValueByCulture[]
  CHAT_REGION?: string
  CHAT_URL?: string
  CLARITY_PROJECT_ID?: string
  ENABLED_FEATURES?: string
  ENVIRONMENT?: Env
  GTM_ID?: string
  HTTP_PORT?: string | number
  MEDIA_ASSET_URL?: string
  OSANO_JS_URL?: string
  CF_RESIZE_ZONE?: string
  CF_IMAGE_ORIGIN?: string
  MAX_SAVED_CARDS?: string | number
  RECAPTCHA_KEY?: string
  RECURLY_KEY?: string
  RECURLYJS_URL?: string
  SIGNIFYD_SCRIPT_URL?: string
  // nuxt.config.ts runtimeConfig.public.applicationinsights; read by plugins/app-insights.client.ts
  applicationinsights?: AppInsightsConfig
  auth: AuthRuntimeConfig
  i18nConfig: I18nRuntimeConfig
}

export type AppRuntimeConfig = {
  BACKEND_SERVER_URL?: string
  CONFIGCAT_CACHE_TIMEOUT?: string
  CONFIGCAT_KEY: string
  public: AppPublicRuntimeConfig
}

export const useTypedRuntimeConfig = () =>
  useRuntimeConfig() as unknown as AppRuntimeConfig
